import { TopDestinations } from './actionTypes';
import { doRequest } from '../../utils/URLUtils';

const requestingTopDestinations = () => ({
    type: TopDestinations.REQUEST_TOP_DESTINATIONS,
});

const receiveTopDestinations = (topDestinations) => ({
    type: TopDestinations.RECEIVE_TOP_DESTINATIONS,
    topDestinations,
});

const formatTopDestinations = (topDestinations) => {
    return topDestinations.map((item) => ({
        ...item,
        city: item.name,
        cityGeoNodeId: item.id,
        geoNodeId: item.id,
        type: 'CITY',
        geoNodeType: 'CITY',
        displayName: item.name,
    }));
};

const fetchTopDestinations = () => {
    const url = '/frontend-home/service/inspirational/topDestinations';

    return (dispatch) => {
        dispatch(requestingTopDestinations());
        return doRequest(url)
            .then((response) => response.json())
            .then((data) => formatTopDestinations(data))
            .then((topDestinations) => {
                dispatch(receiveTopDestinations(topDestinations));
            });
    };
};

const shouldFetchTopDestinations = ({ initial, isFetching }) => {
    return initial && !isFetching;
};

export const getTopDestinations = () => {
    return (dispatch, getState) => {
        const { topDestinations } = getState();
        if (shouldFetchTopDestinations(topDestinations)) {
            return dispatch(fetchTopDestinations());
        } else {
            return Promise.resolve();
        }
    };
};
